import { SkillsContainer } from "../styles/about";
import { LinearLine } from "../styles/porfolio";
import { WindowBlack } from "../styles/home";
import skills from "../data/skills.js";

const Skill = () => {
  // return (
  //   <WindowBlack>
  //     <h1 className="stack-title">Tech Stack</h1>
  //     <SkillsContainer>
  //       <div className="skill-cover">
  //         <p>Languages: </p>
  //         <div>
  //           {skills.languages.map((skill) => (
  //             <span className="languages" key={skill.id}>
  //               {skill.name}
  //             </span>
  //           ))}
  //         </div>
  //       </div>
  //       <div className="skill-cover">
  //         <p>Frontend Stack: </p>
  //         <div>
  //           {skills.frontend.map((skill) => (
  //             <span key={skill.id}>{skill.name}</span>
  //           ))}
  //         </div>
  //       </div>
  //       <div className="skill-cover">
  //         <p>Backend Stack: </p>
  //         <div>
  //           {skills.backend.map((skill) => (
  //             <span className="backend" key={skill.id}>
  //               {skill.name}
  //             </span>
  //           ))}
  //         </div>
  //       </div>
  //       <div className="skill-cover">
  //         <p>Databases: </p>
  //         <div>
  //           {skills.databases.map((skill) => (
  //             <span className="databases" key={skill.id}>
  //               {skill.name}
  //             </span>
  //           ))}
  //         </div>
  //       </div>
  //       <div className="skill-cover">
  //         <p>Other tools: </p>
  //         <div>
  //           {skills.others.map((skill) => (
  //             <span className="other" key={skill.id}>
  //               {skill.name}
  //             </span>
  //           ))}
  //         </div>
  //       </div>
  //     </SkillsContainer>
  //   </WindowBlack>
  // );
};

export default Skill;
